import React, { useEffect } from 'react'
import { result, without } from 'libraries/lodash'
import Grid from '@material-ui/core/Grid'
import { dismissPopover } from 'services/OverlayService'
import SectionHeading from 'pages/documentscontent/precedentsadmin/SectionHeading'
import FileUploadZone from 'pages/documentscontent/precedentsadmin/FileUploadZone'
import SubscriptionSection from 'pages/documentscontent/precedentsadmin/SubscriptionSection'
import DescriptionContainer from 'redux/containers/pages/precedentscontent/precedentsadmin/DescriptionContainer'
import TitleContainer from 'redux/containers/pages/precedentscontent/precedentsadmin/TitleContainer'
import TopLevelSectionContainer from 'redux/containers/pages/precedentscontent/precedentsadmin/TopLevelSectionContainer'
import SubSectionContainer from 'redux/containers/pages/precedentscontent/precedentsadmin/SubSectionContainer'
import PlaceInSectionContainer from 'redux/containers/pages/precedentscontent/precedentsadmin/PlaceInSectionContainer'
import ConfirmModal from 'components/shared/ConfirmModal'

const PrecedentsAdmin = ({
  precedentId,
  files,
  fileName,
  response,
  title,
  parentId,
  pageToggleOverlay,
  setFiles,
  setParents,
  isUpdateMode,
  submitForm,
  updateState,
  resetState
}) => {
  useEffect(() => {
    return () => {
      resetState()
    }
  }, [])

  useEffect(() => {
    setFiles(response.files || null)
    setParents(response.parents || null)
  }, [response])

  useEffect(() => {
    updateState()
  }, [precedentId, files])

  const handleOnSubmit = (e) => {
    dismissPopover(e.target)
    e.stopPropagation()
    e.preventDefault()

    const isDuplicate = ({ checkValue, againstValue }) => {
      const currentId = isUpdateMode ? precedentId : null

      return without(
        result(response, ['parents', parentId], [])
          .filter(fileId => checkValue === files[fileId][againstValue]),
        currentId
      ).length
    }

    //  Allow on edit. Exclude current ID
    if (isDuplicate({ checkValue: title, againstValue: 'title' })) {
      // File exists with the same title.
      pageToggleOverlay(
        <ConfirmModal
          message={`A precedent with a title of "${title}" already exists. Would you like to continue?`}
          confirmText='Yes'
          cancelText='No'
          confirmAction={() => {
            pageToggleOverlay(null)
            submitForm()
          }}
        />
      )
    } else if (isDuplicate({ checkValue: fileName, againstValue: 'name' })) {
      // File exists with the same fileName.
      pageToggleOverlay(
        <ConfirmModal
          message={`A precedent with the file name of "${fileName}" already exists. Would you like to continue?`}
          confirmText='Yes'
          cancelText='No'
          confirmAction={() => {
            pageToggleOverlay(null)
            submitForm()
          }}
        />
      )
    } else {
      // Neither title nor filename already exist. Submit.
      submitForm()
    }
  }

  return (precedentId !== 'new' && precedentId && (!files || !Object.prototype.hasOwnProperty.call(files, precedentId)))
    ? null
    : (
      <div className='bg-ghost-grey pb10'>
        <div className='layout-width-constraint bg-white pb8'>
          <SectionHeading {...{ precedentId }} />
          <form onSubmit={handleOnSubmit}>
            <Grid container spacing={3}>
              <FileUploadZone />
              <TitleContainer />
              <DescriptionContainer />
              <TopLevelSectionContainer {...{ response }} />
              <SubSectionContainer {...{ response }} />
              {precedentId === 'new' && <PlaceInSectionContainer />}
              <SubscriptionSection />
            </Grid>
          </form>
        </div>
      </div>
      )
}

export default PrecedentsAdmin
